// extracted by mini-css-extract-plugin
module.exports = {"cursorWrapper":"GlobalCursor_cursorWrapper__d5Kul","pressed":"GlobalCursor_pressed__k1_Iw"};